/**
 * Created by Shaun on 18/03/2017.
 */

export default function (file) {
  if (_.get(file, 'name') === null) {
    file.icon = 'file';

    return file;
  }

  let fileNameSplit = file.name.split('.');
  let ext = fileNameSplit[fileNameSplit.length - 1];

  switch (ext){
    case 'pdf':
      file.icon = 'file-pdf';
      break;
    case 'docx':
      //really its docx
      file.icon = 'file-word';
      break;
    case 'xlsx':
    case 'xlsxm':
      file.icon = 'file-excel';
      break;
    case 'zip':
    case 'rar':
      file.icon = 'archive';
      break;
    case 'jpeg':
    case 'jpg':
    case 'png':
    case 'gif':
      file.icon = 'image';
      break;
    default:
      file.icon = 'file';
      break;
  }

  return file;
}